import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { PermissionsService } from '../permissions.service';

/**
 * @example
 * <elemento *allowed="'permission'"/>
 *
 * @description funciona como um *ngIf porém usa as permissoes como base
 */

@Directive({
  selector: '[allowed]',
  standalone: true,
})
export class AllowedDirective implements OnChanges {
  @Input() allowed: string | string[] = '';

  constructor(
    private readonly _templateRef: TemplateRef<any>,
    private readonly _viewContainer: ViewContainerRef,
    private readonly _permissionsService: PermissionsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof this.allowed === 'string') {
      this.handlePermissionString();
    } else {
      this.handlePermissionArray();
    }
  }

  handlePermissionString(): void {
    let isAllowed: boolean = this._permissionsService.checkHavePermissions(
      this.allowed.toString()
    );

    this.handleEmbeddedView(isAllowed);
  }

  handlePermissionArray(): void {
    let allowed: string[] = [...this.allowed];
    let isAllowed: boolean = false;

    allowed.forEach((permission) => {
      isAllowed = this._permissionsService.checkHavePermissions(permission)
        ? true
        : isAllowed;
    });

    this.handleEmbeddedView(isAllowed);
  }

  handleEmbeddedView(isAllowed: boolean): void {
    if (isAllowed) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
